// React
import { createContext } from "react";

export const SectionContext = createContext({
  context: "",
  path: [],
});
